import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpTV'

//LIST OF ALL HIGHLIGHTS
export const getHighlights = (params = '') => Http.get(`/highlights-banners${serialize(params)}`)
export const highlightByID = (params = '') => Http.get(`/highlights-banners/${params}`)
export const saveHighlight = (params = '') => Http.post('/highlights-banners', params)
export const updateHighlight = (params = '') => Http.put(`/highlights-banners/${params.id}`, params)
export const deleteHighlight = (params = '') => Http.delete(`/highlights-banners/${params.id}`)
